import MapOptions = google.maps.MapOptions;
import { mapStyle } from '@shared/components/map/const';

export const mapOptions = (center: google.maps.LatLng, zoom: number): MapOptions => ({
  disableDefaultUI: true,
  zoom,
  center,
  gestureHandling: 'cooperative',
  mapTypeControl: false,
  fullscreenControl: false,
  styles: mapStyle,
  maxZoom: 18,
});
